import PropTypes from 'prop-types';
import Modal from '../../../../../components/Modal/index';
import { faPlus } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useEffect, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { questionTypes } from '../../../utils/contants';
import '../../../style/myContent.css';
import { useCreateResourceSetMutation } from '../../../../../features/authentication/qSetApiSlice';
import CustomToast from '../../../../../components/Toast';
import ActivityTypes from '../../../../../enums/activityTypes';
import { useNavigate } from 'react-router';
import { useMyContentContext } from '../../../utils/myContentContext';

const CreateQuestionSetModel = ({
  isOpen,
  onClose,
  showQuestionOptions,
  onCreateSuccess
}) => {
  const [isWaiting, setIsWaiting] = useState(false);
  const [name, setName] = useState('');
  const { setQuestionSetName, setQuestionSetId, resetContext} = useMyContentContext();
  const [createQuestionSet] = useCreateResourceSetMutation();
  const navigate = useNavigate();

  const handleCreateQuestionSet = async () => {
    setIsWaiting(true);
    const option = {
      description: name,
      activityType: ActivityTypes.Assignment
    };

    try {
      const result = await createQuestionSet(option);
      if (result.error) {
        if (result.error.data.errors)
          CustomToast(result.error.data.errors.Description, 'error');
        else
          CustomToast(result.error.data.error, 'error');
      }
      else {
        CustomToast('Question Set Created', 'success');
        setQuestionSetName(name);
        setQuestionSetId(result.data);
        onClose();
        if(showQuestionOptions)
          navigate(`${result.data}/questions`);
        else{
          onCreateSuccess(parseInt(result.data));
        }
      }
    } catch (error) {
      console.log(error);
    }
    setIsWaiting(false);
  };

  useEffect(() => {
    setName('');
  }, [isOpen]);

  return(
    <Modal isOpen={isOpen} titleName={'Create Question Set'} onClose={onClose} contentWidth="655px">
      <div>
        <label className='form-label fw-normal'>Set Name</label>
        <div className='d-flex align-items-center gap-3'>
          <input
            onChange={(e) => setName(e.target.value)}
            type="text"
            className='form-control col'
          />
          <button
            onClick={() => handleCreateQuestionSet()}
            className='btn btn-castleRed btn-width' disabled={!name.trim().length > 0 || name.length > 50 || isWaiting}>
            Save
          </button>
        </div>
        {name.length > 50 &&
          <div className="text-danger">Set Name has exceeded a limit of 50 characters!</div>
        }
      </div>
      {showQuestionOptions &&
      <>
        <div className='my-3 d-flex align-items-center divider-line'>
          <div/>
          <span className='mx-2 fs-14'>OR</span>
          <div/>
        </div>
        <div>
          <h2 className='fw-500'>Select Questions</h2>
          <p>Select the questions first, then create a new question set.</p>
          <Row className='g-3'>
            {questionTypes.map((item) => (
              <Col className={`${item.id == 'castleQuestion' ? 'col-12' : 'col-6'}`} key={item.id}>
                <button
                  className='w-100 p-2 btn-questionset text-start cursor-pointer'
                  onClick={() => {resetContext();navigate(item.path);}} 
                >
                  <div className='align-items-center d-flex'>
                    <div className='align-items-center blue-icon d-flex fs-5 justify-content-center'><FontAwesomeIcon icon={faPlus} /></div>
                    <p className='m-0'>{item.title}</p>
                  </div>
                </button>
              </Col>
            ))}
          </Row>
        </div>
      </>
      }
    </Modal>
  );
};

CreateQuestionSetModel.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  showQuestionOptions: PropTypes.bool,
  onCreateSuccess: PropTypes.func
};

export default CreateQuestionSetModel;
  
